import React, { useEffect, useRef, useState } from "react";
import "./styles.css";

/**
 * @function UITextInput
 * @param {STRING} className - Additional classes to add to the UITextInput.
 * @param {STRING} placeholder - Sets the placeholder text.
 * @param {STRING} value - Lets us set a default value if we need to.
 * @param {ReactDOM} inputField - Allows us to target the DOM.
 * @param {FUNCTION} onChange - Allows us to listen for an interaction with the input.
 * @param {dataPoint} dataPoint - data-point to add to wrapper for captures. 
 * @return {React.Component}
 * @exported true
 * @description The UITextInput is an input with placeholder text.
 * @example
 * <UITextInput className="added-style" placeholder="User ID" />
 */
export default function UITextInput(props) {
  const [ state, setState ] = useState(props.value ?? "");

  const ref = useRef();
  const className = props.className ?? "";
  const placeholder = props.placeholder ?? "";
  const dataPoint = props.dataPoint ? { "data-point": props.dataPoint } : {};

  // Prop used to immediately set the entered value when "onChange"
  // is called and not wait for values passed to be set.
  const setInputValueOnChange = props.setInputValueOnChange ?? true;

  const onChange = evt => {
    if(props.onChange instanceof Function) {
      if(setInputValueOnChange) setState(ref.current.value);
      props.onChange(ref.current.value, evt);
    } else {
      setState(ref.current.value);
    }
  }

  const onFocus = evt => props.onFocus instanceof Function
  ? props.onFocus(ref.current.value, evt)
  : setState(ref.current.value);

  const onBlur = evt => props.onBlur instanceof Function
  ? props.onBlur(ref.current.value, evt)
  : setState(ref.current.value);
  
  useEffect(() => setState(props.value ?? ""), [ props.value ]);
  let disabled = props.disabled ? {disabled:true}:{}; 

  return (
    <input type="text" ref={ref} className={className + " ui-text-input"} value={ state }  placeholder={placeholder} onChange={ onChange } onFocus={onFocus} onBlur={onBlur} autoComplete="off" { ...dataPoint }  {...disabled}/>
  );
}